/**
 * components/settings/SettingsSaveBar.tsx
 *
 * Barre de sauvegarde contextuelle, affichée en position fixe en bas de l'écran
 * uniquement lorsque l'utilisateur a des modifications non enregistrées dans le profil.
 * Updated: responsive left offset - full-width on mobile, offset by sidebar on lg+ screens.
 * Updated: animation CSS translate-y pour une entrée/sortie fluide (conforme au Design System
 *   pattern SaveBar). La barre reste dans le DOM en permanence - jamais démontée -
 *   pour garantir une transition douce sans saut visuel.
 * Updated: added aria-hidden={!visible} so screen readers ignore the bar when hidden.
 */

import Button from '../ui/Button';

interface SettingsSaveBarProps {
  visible: boolean;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export default function SettingsSaveBar({ visible, saving, onSave, onCancel }: SettingsSaveBarProps) {
  return (
    <div
      className={`fixed bottom-0 inset-x-0 lg:left-[280px] z-30 bg-white border-t border-neutral-200 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] transition-transform duration-300 ease-out ${
        visible ? 'translate-y-0' : 'translate-y-full pointer-events-none'
      }`}
      aria-hidden={!visible}
    >
      <div className="flex items-center justify-between px-6 py-3">
        <p className="text-sm text-neutral-600">Modifications non enregistrées</p>
        <div className="flex items-center gap-2">
          <Button variant="ghost" onClick={onCancel} disabled={saving}>
            Annuler
          </Button>
          <Button variant="primary" onClick={onSave} loading={saving}>
            Enregistrer
          </Button>
        </div>
      </div>
    </div>
  );
}
